import React, { useEffect } from "react";

/**
 * SEO — client-side <title>, meta description, canonical, and JSON-LD.
 * For a CRA app, this is applied on route change.
 */
export default function SEO({ title, description, canonical, schema }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    // JSON-LD
    let sd = document.head.querySelector('script[data-jsonld="page"]');
    if (schema) {
      if (!sd) {
        sd = document.createElement("script");
        sd.type = "application/ld+json";
        sd.setAttribute("data-jsonld", "page");
        document.head.appendChild(sd);
      }
      sd.textContent = JSON.stringify(schema);
    } else if (sd) {
      sd.remove();
    }
  }, [title, description, canonical, schema]);

  return null;
}
